(function () {
  'use strict';

  // ── SELECTORS ─────────────────────────────────────────
  const grid = document.querySelector(
    'ul.grid.product-grid, .product-grid, .collection-product-grid'
  );
  const pagination = document.querySelector('.pagination-wrapper');

  if (!grid || !pagination) {
    console.warn('[InfiniteScroll] Grid or pagination missing');
    return;
  }

  // ── GET NEXT PAGE URL ────────────────────────────────
  function getNextUrl(container) {
    const nextLink =
      container.querySelector('a[rel="next"]') ||
      container.querySelector('.pagination__item--next a') ||
      container.querySelector('a[aria-label*="Next"]');

    return nextLink ? nextLink.href : null;
  }

  let nextUrl = getNextUrl(pagination);
  let isLoading = false;
  let prefetchedHTML = null;

  console.log('[InfiniteScroll] Initial nextUrl:', nextUrl);

  if (!nextUrl) return;

  // ── KEEP SEO SAFE (HIDE ONLY VISUALLY) ───────────────
  pagination.style.display = 'none';

  // ── LOADER UI ───────────────────────────────────────
  const loader = document.createElement('div');
  loader.id = 'infinite-loader';
  loader.innerText = 'Loading more products...';
  loader.style.textAlign = 'center';
  loader.style.padding = '20px';
  loader.style.fontSize = '14px';
  loader.style.display = 'none';

  grid.parentElement.appendChild(loader);

  // ── TRIGGER ELEMENT ─────────────────────────────────
  const trigger = document.createElement('div');
  trigger.style.height = '1px';
  trigger.style.marginTop = '20px';
  grid.appendChild(trigger);

  // ── PREFETCH NEXT PAGE (BACKGROUND) ────────────────
  function prefetchNext() {
    if (!nextUrl) return;

    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        prefetchedHTML = html;
        console.log('[Prefetch] Next page cached');
      })
      .catch(() => {});
  }

  // Initial prefetch
  prefetchNext();

  // ── LOAD MORE FUNCTION ─────────────────────────────
  async function loadMore() {
    if (isLoading || !nextUrl) return;

    isLoading = true;
    loader.style.display = 'block';
    loader.innerText = 'Loading more products...';

    try {
      let doc;

      // Use prefetched HTML if available
      if (prefetchedHTML) {
        doc = new DOMParser().parseFromString(prefetchedHTML, 'text/html');
        prefetchedHTML = null;
      } else {
        const res = await fetch(nextUrl);
        if (!res.ok) throw new Error('Network error');
        const html = await res.text();
        doc = new DOMParser().parseFromString(html, 'text/html');
      }

      const newGrid = doc.querySelector(
        'ul.grid.product-grid, .product-grid, .collection-product-grid'
      );

      if (!newGrid) {
        console.warn('[InfiniteScroll] No products found');
        return;
      }

      const items = [...newGrid.children];

      items.forEach((item, i) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(10px)';
        item.style.transition = 'all 0.3s ease';

        grid.appendChild(item);

        // smooth reveal
        setTimeout(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, i * 40);
      });

      // Update next URL
      const newPagination = doc.querySelector('.pagination-wrapper');
      nextUrl = newPagination ? getNextUrl(newPagination) : null;

      console.log('[InfiniteScroll] Next URL:', nextUrl);

      // Prefetch next again
      if (nextUrl) {
        prefetchNext();
      } else {
        observer.disconnect();
        loader.innerText = '✓ All products loaded';
      }

    } catch (err) {
      console.error('[InfiniteScroll] Error:', err);
      loader.innerText = 'Error loading products';
    }

    isLoading = false;
    loader.style.display = nextUrl ? 'none' : 'block';
  }

  // ── INTERSECTION OBSERVER (EARLY LOAD) ─────────────
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadMore();
        }
      });
    },
    {
      root: null,
      rootMargin: '800px', // 🔥 LOAD EARLY (key fix)
      threshold: 0
    }
  );

  observer.observe(trigger);

  // ── SCROLL FALLBACK (SAFETY NET) ───────────────────
  window.addEventListener('scroll', () => {
    if (isLoading || !nextUrl) return;

    const scrollBottom = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;

    if (scrollBottom >= pageHeight - 300) {
      console.log('[InfiniteScroll] Scroll fallback triggered');
      loadMore();
    }
  });

})();